import { Component, Input, EventEmitter, Output, OnInit, inject } from "@angular/core";

import { PermissionsService } from "./../../../shared/services";
import { Task } from "../../../shared/types";
import { TaskFormResult } from "../../types/task-form-result";
import { DynamicFormConfig } from "../../../shared/modules/ngx-dynamic-forms/entities/form-group";

@Component({
	selector: "ic-tasks-detail-view",
	templateUrl: "tasks-detail-view.component.html",
	styleUrls: ["tasks-detail-view.component.scss"],
	standalone: false,
})
export class TasksDetailViewComponent implements OnInit {
	private readonly permissionsService = inject(PermissionsService);

	// @ts-expect-error TS2564
	@Input() task: Task;
	@Input() breadcrumbs?: string;
	// @ts-expect-error TS2564
	@Input() formConfig: DynamicFormConfig;
	// @ts-expect-error TS2564
	@Input() permissions: string[];
	@Output() create = new EventEmitter<TaskFormResult>();

	// @ts-expect-error TS2564
	protected hasPermission: boolean;

	ngOnInit(): void {
		this.hasPermission = this.permissions ? this.permissionsService.userHasPermissions(this.permissions) : true;
	}

	onCreate(result: TaskFormResult) {
		this.create.emit(result);
	}
}
